import { useUnit } from 'effector-react';
import { useKeycloak } from '@react-keycloak/web';
import { useRef, useState } from 'react';
import { SvgIcon } from '@/components/UI/Common/SvgIcon';
import { $user } from '@/models/user';

export const ProfileBar: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { keycloak } = useKeycloak();
  const user = useUnit($user);
  const closeTimerRef = useRef<number | null>(null);

  const handleLogout = async () => {
    try {
      await keycloak.logout();
    } catch (err) {
      console.error(err);
    } finally {
      console.log('logout');
    }
  };

  const openDropdown = () => {
    setIsDropdownOpen(true);
  };

  const scheduleClose = (delay = 150) => {
    if (closeTimerRef.current) window.clearTimeout(closeTimerRef.current);
    closeTimerRef.current = window.setTimeout(() => {
      setIsDropdownOpen(false);
      closeTimerRef.current = null;
    }, delay);
  };

  const handleMenuKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    // Close menu on Escape
    if (e.key === 'Escape' || e.key === 'Esc') {
      setIsDropdownOpen(false);
    }
  };

  return (
    <div className="profile-bar relative">
      <button
        type="button"
        className="flex items-center cursor-pointer"
        aria-haspopup="menu"
        aria-expanded={isDropdownOpen}
        aria-controls="profile-menu"
        onFocus={openDropdown}
        onMouseEnter={openDropdown}
        onTouchStart={openDropdown}
      >
        <div className="text-right">
          <div className="text-white font-medium text-sm underline relative pr-5 mb-2">
            {user?.name}
            <svg
              className="absolute right-0 top-1 w-3 h-3 text-white"
              viewBox="0 0 12 12"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M6 8.825L1.175 4 2.25 2.925 6 6.675 9.75 2.925 10.825 4z" />
            </svg>
          </div>
        </div>
      </button>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div
          id="profile-menu"
          className="absolute top-full -right-2 mt-1 z-50"
          onMouseEnter={openDropdown}
          onMouseLeave={() => scheduleClose(150)}
          onTouchStart={openDropdown}
          role="menu"
          aria-label="Profile menu"
          tabIndex={0}
          onKeyDown={handleMenuKeyDown}
          onFocus={openDropdown}
          onBlur={() => scheduleClose(150)}
        >
          <nav className="bg-[#3b4069] rounded shadow-xl py-6 min-w-48">
            <MenuItem icon={'logout'} title={'Выйти из аккаунта'} onClick={handleLogout} />
          </nav>
        </div>
      )}
    </div>
  );
};

const MenuItem = ({
  title,
  icon,
  href,
  onClick,
}: {
  title: string;
  icon: string;
  onClick?: VoidFunction;
  href?: string;
}) => {
  return (
    <li
      onClick={onClick}
      className="px-5 py-2 text-white hover:no-underline hover:bg-white/10 transition-colors duration-200 underline list-none cursor-pointer"
    >
      <a className="flex gap-5 items-center whitespace-nowrap" href={href}>
        <i>{<SvgIcon name={icon} />}</i>
        <span>{title}</span>
      </a>
    </li>
  );
};
